export default "/images/6e0df4a659464c9c1783f85a6c63b1ec.avif";